module.exports = __webpack_public_path__ + "img/banner3_0.806204e5.jpg";